module.exports = "/_next/static/images/ea693a34ebc09dac521b92512a2a26e8-hot-sale-hero-desktop.jpg";